import React from 'react';

interface StorySlideProps {
  background: string;
  children?: React.ReactNode;
}

const StorySlide: React.FC<StorySlideProps> = ({ background, children }) => (
  <div className="story-slide" style={{ background }}>
    {children}
  </div>
);

export default StorySlide;
